/** Default chrome for AI Recommendation Upsell (layoutConfig.options). */
export const AI_RECOMMENDATION_UPSELL_DEFAULT_OPTIONS = {
  showBestsellerBadge: true,
  bestsellerLabel: "BESTSELLER",
  showRating: true,
  ratingValue: "4.9",
  reviewCount: 2841,
  showSocialProofAvatars: true,
  volumeDiscountText: "Buy 2 → Extra 10% off",
  priceSubLabel: "One-time · No subscription",
};

/** Legacy layoutConfig visibility flags — always on; blocks live in schema. */
const CATALOG_BLOCK_VISIBILITY = {
  showAiSummaryRibbon: true,
  showSocialProof: true,
  showVariantPicker: true,
  showQuantityAndVolume: true,
  showTrustBadges: true,
};

export function mergeAiRecommendationUpsellOptions(raw = {}) {
  return {
    ...AI_RECOMMENDATION_UPSELL_DEFAULT_OPTIONS,
    ...(raw && typeof raw === "object" ? raw : {}),
    ...CATALOG_BLOCK_VISIBILITY,
  };
}
